function addBooking() {
    document.querySelectorAll('.js-booking-trigger').forEach( trigger => {
        trigger.addEventListener('click', () => {
            document.querySelector(`[data-trigger="${trigger.dataset.target}"]`).classList.toggle('hidden');
        })
    })
    document.querySelectorAll('.js-booking-option').forEach( option => {
        option.addEventListener('click', () => {

            switch(option.dataset.target) {
                case 'rooms':
                    document.querySelector('.js-input-container').innerHTML = '';
                    document.querySelector('.js-input-container').dataset.value = option.dataset.value;
                    let roomValue=[];
                    if(parseInt(option.dataset.value) > parseInt(document.querySelector('.js-guests').value)){
                        document.querySelector('.js-guests').value = option.dataset.value;
                        document.querySelector(`.js-booking-trigger[data-target="adults"]`).textContent = option.dataset.value;
                    
                    } else {
                        let guestCount = document.querySelector('.js-guests').value;
                        for(let i = 0; i <  option.dataset.value; i++){
                            guestCount = guestCount - 2;
                            roomValue[i] = guestCount >= 0 ? 2 :1 ;
                        }
                    }

                    for(let i = 0; i < option.dataset.value; i++){
                        let input = document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', `room${i + 1}NumAdults`);
                        input.setAttribute('value', `${  document.querySelector('.js-guests').value == option.dataset.value ? '1' : roomValue[i] }`);
                        document.querySelector('.js-input-container').appendChild(input);
                    }
                    break;
                case 'adults':
                    document.querySelector('.js-input-container').innerHTML = '';
                    let roomsValue = [];
                    
                        let guestCount = parseInt(option.dataset.value);
                        console.log(guestCount);
                        for(let i = 0; i <  document.querySelector('.js-input-container').dataset.value; i++){
                            guestCount = guestCount - 2;
                            roomsValue[i] = guestCount >= 0 ? 2 :1 ;
                        }
                    

                    for(let i = 0; i < document.querySelector('.js-input-container').dataset.value; i++){
                        
                        let input = document.createElement('input');
                        input.setAttribute('type', 'hidden');
                        input.setAttribute('name', `room${i + 1}NumAdults`);
                        input.setAttribute('value', `${  parseInt(option.dataset.value) == document.querySelector('.js-input-container').dataset.value ? '1' : roomsValue[i] }`);
                        document.querySelector('.js-input-container').appendChild(input);
                    }

                    
                    document.querySelector(`[name=${option.dataset.target}]`).value = option.dataset.value;
                    break;
                default:
                    document.querySelector(`[name=${option.dataset.target}]`).value = option.dataset.value;
                    break; 
            }


            
            document.querySelector(`.js-booking-pop[data-trigger="${option.dataset.trigger}"]`).classList.add('hidden');
            option.parentElement.querySelectorAll('.js-booking-option').forEach( o => o.classList.remove('active'));
            option.classList.add('active');
            document.querySelector(`.js-booking-trigger[data-target="${option.dataset.trigger}"]`).textContent = option.textContent;
        })
    })

    //calendar
    const CALENDAR_CONTAINER =  document.querySelector('#bookingCalendars');

    let startDate = document.querySelector('#bookingCheckIn').value;
    let endDate = document.querySelector('#bookingCheckOut').value;


  

    flatpickr(CALENDAR_CONTAINER, {
        mode: "range",
        dateFormat: "Y-m-d",
        inline: true,
        showMonths: window.innerWidth > 1025 ? 2 : 1,
        minDate: new Date(),
        onDayCreate: function(dObj, dStr, fp, dayElement) {
            dayElement.removeAttribute('aria-label');
        },
        onChange: function (selectedDates, dateStr, instance) {
            if (selectedDates.length == 1) {
                document.querySelector('#bookingCheckIn').value = dateStr;
                document.querySelector('#bookingCheckOut').value = dateStr;
            } else {
                let separatedDate = dateStr.split(' to ');
                document.querySelector('#bookingCheckIn').value = separatedDate[0];
                document.querySelector('#bookingCheckOut').value = separatedDate[1];
            }
            let finalDate = dateStr.replace(' to ', ' | ');
            document.querySelector('#dates').value = finalDate.replace(/-/g, '/');
        }
    });

}